import paduLogo from '@/assets/padu_new_logo_sign.png';
import openLogo from '@/assets/images/redirect-landing/open.png';
import madLogo from '@/assets/images/redirect-landing/mad.png';
import realNewsLogo from '@/assets/images/redirect-landing/realnews.jpeg';
import kathimeriniLogo from '@/assets/images/redirect-landing/kathimerini.jpg';
import manessisLogo from '@/assets/images/redirect-landing/manessistravel.jpeg';
import metritaLogo from '@/assets/images/redirect-landing/metrita.jpg';
import betssonLogo from '@/assets/images/redirect-landing/betsson.jpg';
import greenCityLogo from '@/assets/images/redirect-landing/green-city.webp';
import oneChannelLogo from '@/assets/images/redirect-landing/one-channel.jpg';
import disneyLogo from '@/assets/images/redirect-landing/disney-logo.jpg';
import novaLogo from '@/assets/images/redirect-landing/nova.jpg';

export type CampaignType = 'partner' | 'download' | 'couponset';

export type Campaign = {
  slug: string; //unique identifier
  type: CampaignType;
  paths: string[]; //url paths that trigger this campaign
  name: string;
  title: string;
  description: string;
  logo?: string;
};

const PARTNER_BLURB =
  'Κατέβασε το PADU και ξεκλείδωσε την προσφορά σου. Το κορυφαίο app επιβράβευσης στην Ελλάδα σε ανταμείβει σε κάθε αγορά!';

export const CAMPAIGNS: Campaign[] = [
  
  // Partner Redirects 
  {
    slug: 'open_tv',
    type: 'partner',
    paths: ['/qr-open/'],
    name: 'OPEN TV',
    title: 'Καλώς ήρθες από το OPEN TV!',
    description: PARTNER_BLURB,
    logo: openLogo,
  },
  {
    slug: 'mad_tv',
    type: 'partner',
    paths: ['/qr-mad/'],
    name: 'MAD TV',
    title: 'Καλώς ήρθες από το MAD TV!',
    description: PARTNER_BLURB,
    logo: madLogo,
  },
  {
    slug: 'real_news',
    type: 'partner',
    paths: ['/qr-real/'],
    name: 'Real News',
    title: 'Καλώς ήρθες από τη Real News!',
    description: PARTNER_BLURB,
    logo: realNewsLogo,
  },
  {
    slug: 'kathimerini',
    type: 'partner',
    paths: ['/qr-kathimerini/'],
    name: 'Καθημερινή',
    title: 'Καλώς ήρθες από την Καθημερινή!',
    description: PARTNER_BLURB,
    logo: kathimeriniLogo,
  },
  {
    slug: 'disney',
    type: 'partner',
    paths: ['/qr-disney/'],
    name: 'Disney',
    title: 'Καλώς ήρθες από τη Disney!',
    description: PARTNER_BLURB,
    logo: disneyLogo,
  },
  {
    slug: 'manessis',
    type: 'partner',
    paths: ['/qr-manessis/'],
    name: 'Manessis Travel',
    title: 'Καλώς ήρθες από το Manessis Travel!',
    description: PARTNER_BLURB,
    logo: manessisLogo,
  },
  {
    slug: 'metrita',
    type: 'partner',
    paths: ['/qr-metrita/'],
    name: 'Μετρητά',
    title: 'Καλώς ήρθες!',
    description:
      'Κατέβασε το PADU και κέρδισε. Το κορυφαίο app επιβράβευσης στην Ελλάδα σε ανταμείβει σε κάθε αγορά!',
    logo: metritaLogo,
  },
  {
    slug: 'betsson',
    type: 'partner',
    paths: ['/qr-betsson/'],
    name: 'Betsson',
    title: 'Καλώς ήρθες από την Betsson!',
    description: PARTNER_BLURB,
    logo: betssonLogo,
  },
  {
    slug: 'one_channel',
    type: 'partner',
    paths: ['/qr-one/'],
    name: 'ONE Channel',
    title: 'Καλώς ήρθες από το ONE Channel!',
    description: PARTNER_BLURB,
    logo: oneChannelLogo,
  },

    // TODO: check if printed qr is in greek or english
  {
    slug: 'green_city',
    type: 'partner',
    paths: ['/qr-greencity/', '/συνεργασία-green-city-padu/'],
    name: 'Green City',
    title: 'Καλώς ήρθες από το Green City!',
    description: PARTNER_BLURB,
    logo: greenCityLogo,
  },
  {
    slug: 'nova_loyalty',
    type: 'partner',
    paths: ['/app/nova-loyalty'],
    name: 'Nova',
    title: 'Καλώς ήρθες από τη Nova!',
    description: PARTNER_BLURB,
    logo: novaLogo,
  },





  // Generic download 
  {
    slug: 'qr_download',
    type: 'download',
    paths: [
      '/qr-download/',
      '/qr-download-padu/',
      '/download/',
      '/app/padu/for-you/coupons',
      '/app/padu/couponsets',
    ],
    name: 'PADU',
    title: 'Κατέβασε το PADU',
    description:
      'Το κορυφαίο app επιβράβευσης στην Ελλάδα που σε ανταμείβει σε κάθε αγορά! Κατέβασέ το δωρεάν και ξεκίνα να κερδίζεις.',
    logo: paduLogo,
  },






  //New Nova couponsets 
  {
    slug: 'NOVA_X_COFFEE_LAB_1PLUS1_COFFEE_2025',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_COFFEE_LAB_1PLUS1_COFFEE_2025',
      '/app/couponset/view/NOVA_X_COFFEE_LAB_1PLUS1_COFFEE_2025',
    ],
    name: 'Nova x Coffee Lab',
    title: '1+1 καφές από τα Coffee Lab!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για 1+1 καφέ στα Coffee Lab.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_WOLT_2024',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_WOLT_2024',
      '/app/couponset/view/NOVA_X_WOLT_2024',
    ],
    name: 'Nova x Wolt',
    title: 'Προσφορά Wolt μέσα από το PADU!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά της Wolt.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_BOX_NOW',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_BOX_NOW',
      '/app/couponset/view/NOVA_X_BOX_NOW',
    ],
    name: 'Nova x BOX NOW',
    title: 'Προσφορά BOX NOW μέσα από το PADU!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά της BOX NOW.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_DIMELLO_30SALE_2026',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_DIMELLO_30SALE_2026',
      '/app/couponset/view/NOVA_X_DIMELLO_30SALE_2026',
    ],
    name: 'Nova x Dimello',
    title: '-30% σε προϊόντα Dimello!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για έκπτωση 30% σε προϊόντα Dimello.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_SIGNATURE_TRAVEL10_2025',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_SIGNATURE_TRAVEL10_2025',
      '/app/couponset/view/NOVA_X_SIGNATURE_TRAVEL10_2025',
    ],
    name: 'Nova x Signature Travel',
    title: 'Έκπτωση στα ταξίδια σου με τη Signature Travel!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά της Signature Travel.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_PIZZA_FAN_2024',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_PIZZA_FAN_2024',
      '/app/couponset/view/NOVA_X_PIZZA_FAN_2024',
    ],
    name: 'Nova x Pizza Fan',
    title: 'Προσφορά Pizza Fan μέσα από το PADU!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά της Pizza Fan.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_SIMPLY_BURGERS_2024',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_SIMPLY_BURGERS_2024',
      '/app/couponset/view/NOVA_X_SIMPLY_BURGERS_2024',
    ],
    name: 'Nova x Simply Burgers',
    title: 'Προσφορά Simply Burgers μέσα από το PADU!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά των Simply Burgers.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_AVIS_2025',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_AVIS_2025',
      '/app/couponset/view/NOVA_X_AVIS_2025',
    ],
    name: 'Nova x Avis',
    title: 'Προσφορά Avis μέσα από το PADU!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για την προσφορά της Avis.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_PET_CITY_20SALE_HI_P_K_2025',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_PET_CITY_20SALE_HI_P_K_2025',
      '/app/couponset/view/NOVA_X_PET_CITY_20SALE_HI_P_K_2025',
    ],
    name: 'Nova x Pet City',
    title: '-20% στα Pet City!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για έκπτωση 20% στα Pet City.',
    logo: novaLogo,
  },
  {
    slug: 'NOVA_X_MUSEUM_OF_ILLUSIONS_30SALE_2026',
    type: 'couponset',
    paths: [
      '/app/couponset/NOVA_X_MUSEUM_OF_ILLUSIONS_30SALE_2026',
      '/app/couponset/view/NOVA_X_MUSEUM_OF_ILLUSIONS_30SALE_2026',
    ],
    name: 'Nova x Museum of Illusions',
    title: '-30% στο Museum of Illusions!',
    description:
      'Κατέβασε το PADU και εξαργύρωσε το κουπόνι σου για έκπτωση 30% στο Museum of Illusions.',
    logo: novaLogo,
  },
];

export function findCampaignBySlug(slug: string): Campaign | undefined {
  return CAMPAIGNS.find((c) => c.slug === slug);
}

/**
 * Canonical backend identifier for a campaign path: the last URL segment.
 * Matches how QrRedirect rows are keyed, e.g. "/qr-open/" -> "qr-open" and
 * "/app/couponset/NOVA_X_AVIS_2025" -> "NOVA_X_AVIS_2025".
 */
export function backendPath(path: string): string {
  return path.replace(/^\/+|\/+$/g, "").split("/").pop() ?? "";
}
